<template>
	<cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer"
		ref="table">
		<template #EMAILCONTENT>
			<Tabs v-model="tab" name="C">
				<TabPane v-for="tab in tabs" :label="tab.label" :name="tab.value" :key="tab.value" tab="C">
					<div v-if="tab.value === 'info'">
						<cForm :fields="info.fields" :grid="info.grid" :config="info.config" ref="info"></cForm>
					</div>
					<div v-else-if="tab.value === 'package'">
						<cTable :fields="packages.fields" :footer="{ show: () => false }" :config="packages.config"
							ref="package"></cTable>
					</div>
					<div v-else-if="tab.value === 'email'">
						<cForm :fields="email.fields" :grid="email.grid" :config="email.config" ref="email">
							<template #editor="{params}">
								<editor ref="editor" plugins="advlist autolink link lists charmap wordcount table"
									v-model="params.body"></editor>
							</template>
						</cForm>
					</div>
				</TabPane>
			</Tabs>
		</template>
	</cTable>
</template>

<script>
	import cTable from "@/base/common/index";
	import cForm from "@/base/common/component/form.vue";
	import {
		apis
	} from "@/api/endTripManage/customerClearanceEndTripBill";
	import editor from "_c/tiny-editor";
	import btns from "@/components/tables/handle-btns";
	import {
		bayan,
		upload
	} from "@/api/extract/list";
	export default {
		name: "customerClearanceEndTripBill",
		components: {
			cTable,
			cForm,
			editor
		},
		props: {
			type: {
				type: String,
				default: ""
			}
		},
		mounted() {},
		data() {
			return {
				email: {
					config: {
						formBind: {
							labelWidth: 100
						},
						rowBind: {
							gutter: 16
						},
						colBind: {
							style: {
								marginBottom: "20px"
							}
						},
						rules: {
							mailBox: [{
								type: "array",
								required: true,
								message: "请输入,收件人,邮箱",
								trigger: "blur"
							}],
							subject: [{
								required: true,
								message: "请输入,邮件,标题",
								trigger: "blur"
							}],
							body: [{
								required: true,
								message: "请输入,邮件,内容",
								trigger: "blur"
							}]
						}
					},
					grid: [{
						mailBox: 24,
						subject: 24,
						attachment: 24,
						body: 24,
						save: 24
					}],
					fields: [{
							name: this.$tz("收件人,邮箱"),
							key: "mailBox",
							component: "Select",
							placeholder: () => this.$tz("收件人,邮箱"),
							options: [],
							bind: {
								filterable: true,
								multiple: true,
								"allow-create": true
							}
						},
						{
							name: () => this.$tz("邮件,标题"),
							key: "subject",
							component: "Input",
							placeholder: () => this.$tz("邮件,标题")
						},
						{
							name: () => this.$tz("邮件,内容"),
							key: "body",
							placeholder: () => this.$tz("邮件,内容"),
							solt: "editor"
						},
						{
							name: () => this.$tz("邮件,附件"),
							key: "attachment",
							component: "Upload",
							bind: {
								fileName: true,
								multiple: true,
								isButton: true,
								type: "select"
							},
							default: [],
							methods: {
								fileClick({
									row
								}) {
									this.openUrl(row.src);
								},
								beforeUpload({
									file,
									formData
								}) {
									console.log(this);
									this.$page
										.handleRequestMethods(
											"upload", {
												type: "clearance",
												file,
												id: this.$modal.params.info.id
											},
											true,
											true
										)
										.then(res => {
											formData["attachment"].push({
												filename: file.name,
												title: file.name,
												url: this.$globalUrl + res.payload,
												src: this.$globalUrl + res.payload
											});
										});
									return false;
								}
							}
						},
						{
							name: () => "",
							key: "save",
							component: "Button",
							bind: {
								type: "primary"
							},
							methods: {
								render() {
									return this.$tz("发送");
								},
								click: async () => {
									let form = this.$refs["email"][0];
									let modal = this.$refs["table"].getModal("email");
									let formData = await form.submit();
									formData.awbNumber = modal.params.mail.awbNumber;
									delete formData.save;
									console.log(arguments, formData);
									this.$refs["table"]
										.handleRequestMethods("send_mail", formData, true, true)
										.then(res => {
											this.$refs["table"].getModal("email").close();
										});
								}
							}
						}
					]
				},
				packages: {
					config: {
						slot: "div",
						resize: false,
						height: 600
					},
					fields: [{
							name: () => this.$tz("包裹,单号"),
							key: "packageNumber",
							minWidth: 110
						},
						{
							name: () => this.$tz("订单号"),
							key: "shipmentNumber",
							minWidth: 110
						}
					]
				},
				info: {
					config: {
						formBind: {
							labelWidth: 100
						},
						rowBind: {
							gutter: 16
						},
						colBind: {
							style: {
								marginBottom: "20px"
							}
						}
					},
					fields: [{
							name: () => this.$tz("起运国"),
							key: "from_station",
							component: "Input",
							disabled: () => true,
							placeholder: () => " "
						},
						{
							name: () => this.$tz("目的国"),
							key: "to_station",
							component: "Input",
							disabled: () => true,
							placeholder: () => " "
						},
						{
							name: () => this.$tz("起运机场"),
							key: "from_airport",
							component: "Input",
							disabled: () => true,
							placeholder: () => " "
						},
						{
							name: () => this.$tz("目的机场"),
							key: "to_airport",
							component: "Input",
							disabled: () => true,
							placeholder: () => " "
						},
						{
							name: () => this.$tz("离港时间"),
							key: "depart_date",
							component: "Input",
							disabled: () => true,
							placeholder: () => " "
						},
						{
							name: () => this.$tz("到港时间"),
							key: "arrival_date",
							component: "Input",
							disabled: () => true,
							placeholder: () => " "
						},
						{
							name: () => this.$tz("清关代理"),
							key: "clearance_agent",
							component: "Input",
							disabled: () => true,
							placeholder: () => " "
						}
					],
					grid: [{
						from_station: 12,
						from_airport: 12,
						to_station: 12,
						to_airport: 12,
						depart_date: 12,
						arrival_date: 12,
						clearance_agent: 12
					}]
				},
				tab: "info",
				tabs: [{
						label: this.$tz("基本信息"),
						value: "info"
					},
					{
						label: this.$tz("包裹,信息"),
						value: "package"
					},
					{
						label: this.$tz("发送,邮件"),
						value: "email"
					}
				],
				methods: {
					...apis,
					bayan,
					upload: p => {
						let id = p.id;
						delete p.id;
						let formData = new FormData();
						Object.keys(p).forEach(t => {
							formData.append(t, p[t]);
						});
						console.log(p);
						return upload(formData, id);
					},
					list: p => {
						if (this.type) {
							return apis.tmExtractList(p);
						}
						return apis.list(p);
					}
				},
				config: {},
				footer: {},
				modals: {
					number: {
						config: {
							title: this.$tz("明细"),
							modalBind: {
								width: 1000
							},
							listFn: "shipmentDetails"
						},
						footer: {
							show: () => false
						},
						table: {
							config: {
								height: 600
							},
							header: {
								searchs: [{
									key: "keywords",
									placeholder() {
										return this.$t("keyword");
									},
									component: "Input",
									bind: {
										type: "textarea",
										autosize: {
											minRows: 2,
											maxRows: 2
										}
									}
								}]
							},
							footer: {
								show: () => true
							},
							fields: [{
									name: () => this.$tz("袋子号"),
									key: "package_number",
									minWidth: 130
								},
								{
									name: () => this.$tz("订单号"),
									key: "airway_number",
									minWidth: 130
								},
								{
									name: () => this.$tz("入库重量"),
									key: "check_weight",
									minWidth: 130
								},
								{
									name: () => this.$tz("申报价值"),
									key: "values",
									minWidth: 130
								},
								{
									name: () => this.$tz("起运国"),
									key: "from_country",
									minWidth: 130
								},
								{
									name: () => this.$tz("目的国"),
									key: "to_country",
									minWidth: 130
								},
								{
									name: () => this.$tz("客户,原单号"),
									key: "client_refer_code",
									minWidth: 130
								}
							]
						}
					},
					bayan: {
						config: {
							isNoPage: true,
							listFn: "bayan",
							title: this.$tz("bayan,文件"),
							modalBind: {
								width: 1000
							}
						},
						header: {
							show: () => true,
							btns: [{
								name: () => this.$tz("上传"),
								type: "upload",
								fnName: "upload",
								bind: {
									type: "primary"
								}
							}],
							methods: {
								upload() {
									let el = document.createElement("input");
									el.type = "file";
									el.accept = "application/zip";
									el.click();
									el.addEventListener("input", e => {
										console.log(el.files[0], this.params);
										let formData = new FormData();
										formData.append("file", el.files[0]);
										formData.append("type", 2);
										upload(formData, this.params.id).then(res => {
											if (res.data.status) {
												this.$Message["success"]({
													background: true,
													content: res.data.msg
												});
												this.$page.getModal("bayan").getList();
											}
										});
									});
								}
							}
						},
						footer: {
							show: () => false
						},
						table: {
							config: {
								height: 600
							},
							fields: [{
									name: () => this.$tz("文件,名称"),
									key: "title",
									minWidth: 110
								},
								{
									name: () => this.$tz("操作人"),
									key: "create_name",
									minWidth: 110
								},
								{
									name: () => this.$tz("上传,时间"),
									key: "create_time",
									minWidth: 110
								},
								{
									name: () => this.$t("operation"),
									type: "btns",
									width: 220,
									fixed: "right",
									list: [{
										name: this.$tz("下载"),
										type: "down",
										fnName: "down",
										bind: {
											type: "primary"
										},
										id: ""
									}],
									methods: {
										down({
											row
										}) {
											window.open(row.src, "_blank");
										}
									}
								}
							]
						}
					},
					email: {
						contentSlot: "EMAILCONTENT",
						footer: {
							show: () => false
						},
						config: {
							title: this.$tz("邮件"),
							modalBind: {
								width: 1000,
								styles: {
									top: "10px"
								}
							}
						}
					},
					remarks: {
						config: {
							title: this.$tz("历史记录"),
							modalBind: {
								width: 1000
							}
						},
						footer: {
							show: () => false
						},
						table: {
							config: {
								height: 600
							},
							fields: [{
									name: () => this.$tz("信息"),
									key: "msg",
									minWidth: 110
								},
								{
									name: () => this.$tz("操作时间"),
									key: "ts",
									minWidth: 110
								}
							]
						}
					}
				},
				header: {
					searchs: [{
						key: "keywords",
						placeholder() {
							return this.$t("keyword");
						},
						component: "Input",
						bind: {
							type: "textarea",
							autosize: {
								minRows: 2,
								maxRows: 2
							}
						}
					}],
					btns: {
						list: [],
						methods: {}
					}
				},
				fields: [{
						type: "checkbox",
						width: 60,
						fixed: "left"
					},
					{
						name: () => this.$tz("客户,名称"),
						key: "client_name",
						minWidth: 110
					},
					{
						name: () => this.$t("mawb"),
						key: "mawb",
						align: "left",
						minWidth: 120,
						fixed: "left"
						// header: {
						//   copy: true //头部复制
						// }
					},
					{
						name: () => this.$t("flight"),
						key: "flight",
						minWidth: 100
					},
					{
						name: () => this.$t("allow_depart"),
						key: "from_station",
						minWidth: 80
					},
					{
						name: () => this.$t("allow_arrive"),
						key: "to_station",
						minWidth: 80
					},
					{
						name: () => this.$t("departureAirport"),
						key: "from_airport",
						minWidth: 80
					},
					{
						name: () => this.$t("destinationAirport"),
						key: "to_airport",
						minWidth: 80
					},
					{
						name: () => this.$t("clearagent"),
						key: "clearance_agent",
						minWidth: 120
					},
					{
						name: () => this.$t("depart_date"),
						key: "depart_date",
						minWidth: 115
					},
					{
						name: () => this.$t("toHKtime"),
						key: "arrival_date",
						minWidth: 130
					},
					{
						name: () => this.$t("clearance_date"),
						key: "clearance_date",
						minWidth: 115
					},
					{
						name: () => this.$tz("数量"),
						key: "nums",
						minWidth: 110,
						component: "Button",
						bind: {
							type: "primary",
							size: "small"
						},
						disabled: ({
							value
						}) => !value,
						methods: {
							click({
								row
							}) {
								console.log(row);
								this.$page.getModal("number").open(row, function() {
									this.pageConfig.data = {
										id: row.id
									};
									this.setTitle(`${this.$tz("明细")}(${row.mawb})`);
									this.getList();
								});
							}
						}
					},
					{
						name: () => this.$tz("提单,重量"),
						key: "weight",
						minWidth: 115
					},
					{
						name: () => this.$tz("包裹,总,重量"),
						key: "check_weight",
						minWidth: 110
					},
					{
						name: () => this.$tz("运输方式"),
						key: "transportation_type",
						minWidth: 110,
						bind: {
							style: {
								color: "red"
							}
						}
					},
					{
						name: () => this.$tz("状态"),
						key: "statusDesc",
						minWidth: 200
					},
					{
						name: () => this.$tz("提单,上传,时间"),
						key: "attachUploadTime",
						minWidth: 150
					},
					{
						name: () => this.$t("createTime"),
						key: "create_time",
						minWidth: 115
					},
					{
						name: () => this.$t("operation"),
						type: "btns",
						width: 220,
						fixed: "right",
						list: [{
								name: this.$tz("历史记录"),
								type: "history",
								fnName: "history",
								bind: {
									type: "primary"
								}
							},
							{
								name: () => this.$tz("发送,邮件"),
								type: "email",
								fnName: "email",
								bind: {
									type: "primary"
								}
							},
							{
								name: () => this.$tz("bayan"),
								type: "bayan",
								bind: {
									type: "primary"
								},
								fnName: "bayan"
							}
						],
						methods: {
							bayan({
								row
							}) {
								this.getModal("bayan").open(row, function() {
									this.setTitle(this.$tz("bayan"));
									this.pageConfig.data.id = row.id;
									this.pageConfig.data.type = 2;
									this.getList();
								});
							},
							history({
								row
							}) {
								this.getModal("remarks").open(null, function() {
									this.setTitle(this.$tz("历史记录"));
									this.list = row.remarks;
								});
							},
							email: ({
								row
							}) => {
								let table = this.$refs["table"];
								let page = this;
								table
									.handleRequestMethods(
										"info", {
											keywords: row.mawb,
											withShipment: 1
										},
										false,
										true
									)
									.then(info => {
										info = info.payload.rows[0];
										console.log(info);
										table
											.handleRequestMethods(
												"read", {
													awb: row.mawb
												},
												false,
												true
											)
											.then(res => {
												console.log(res);
												let mail = {
													awbNumber: row.mawb,
													id: row.id,
													mailBox: res.payload.mailBox,
													subject: res.payload.title,
													body: res.payload.body,
													attachment: res.payload.files.map(t => {
														t.filename = t.title;
														t.src = t.url;
														return t;
													})
												};
												page.email.fields[0].options = res.payload.mailBox.map(
													t => {
														return {
															value: t,
															label: t
														};
													}
												);
												page.tab = "info";
												table.getModal("email").open({
													mail,
													info
												}, function() {
													this.setTitle(this.$tz("发送,邮件") +
														`(${row.mawb})`);
													page.$refs["editor"][0].handleInit();
													page.$refs["package"][0].list = info.shipments;

													page.$refs["info"][0].setFormData(info);
													page.$refs["email"][0].setFormData(mail);
												});
											});
									});
							}
						}
					}
				]
			};
		}
	};
</script>

<style scoped></style>